import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUpdateFolderRequestFailure() {
      return getState().isFailure;
    },
    isUpdateFolderRequestPending() {
      return getState().isPending;
    },
    isUpdateFolderRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
